(ns client-portal.client.voice-insights.items.charts.views
  (:require [client-portal.client.layout :as l]
            [client-portal.client.voice-insights.items.charts.data :as items.charts.d]
            [client-portal.client.voice-insights.items.data :as items.d]
            [clojure.string :as s]
            [shared.core.regexes :as regexes]
            [shared.core.components.components :as c]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.recharts-components :as recharts.c]
            [shared.core.components.recharts.util :as recharts.util]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [client-portal.client.voice-insights.tags.data :as tags.d]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [shared.core.reactive :as re]
            [shared.core.router :as router]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(defn build-reason->reason-raw [data]
  (some->> (util/when-not-loading data)
           (mapv (fn [{:keys [reason reason-raw]}]
                   [reason reason-raw]))
           (into {})))

(defn build-result->result-raw [data]
  (some->> (util/when-not-loading data)
           (mapv (fn [{:keys [result result-raw]}]
                   [result result-raw]))
           (into {})))

(defn build-question-value->question-value-raw [data]
  (some->> (util/when-not-loading data)
           (mapv (fn [{:keys [question-value question-value-raw]}]
                   [question-value question-value-raw]))
           (into {})))

(defn build-daily-day->time-value [data]
  (some->> data
           :daily
           :data
           (mapv (fn [{:keys [day time-value]}]
                   [day time-value]))
           (into {})))

(defn unavailable-items-by-reason-card []
  (let [grouping-form-path items.charts.d/charts-settings-path
        grouping-form-name :unavailable-items-by-reason-grouping-value
        selected-grouping @(re/subscribe [:form/val- grouping-form-path grouping-form-name])
        all-charts-data @(re/subscribe [:vi-items/charts-data-])
        sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        unavailable-items-by-reason (some-> (util/when-not-loading all-charts-data)
                                            :unavailable-items-by-reason
                                            (util/when-not-empty))
        data? (or (util/loading? all-charts-data) unavailable-items-by-reason)
        {:keys [data top-20-keys]} unavailable-items-by-reason
        reason->reason-raw (build-reason->reason-raw data)
        chart-data (some->> data
                            (#(if (= selected-grouping "all")
                                %
                                (filterv (fn [{:keys [item]}] (contains? top-20-keys item)) %)))
                            (sort-by :total-count)
                            (reverse)
                            (hash-map :source-key :item
                                      :sort-sources-by-key? true
                                      :source-colors items.d/item-color
                                      :target-key :reason
                                      :sort-targets-by-key? true
                                      :target-config {:color (tag.d/utterance-tag-name->color "unavailable")
                                                      :header-description-fn #(tag.d/tag->description
                                                                                {:name "unavailable"
                                                                                 :value (reason->reason-raw (:name %))})}
                                      :value-key :count
                                      :data)
                            (recharts.util/build-sankey-data))]
    [alc/card {:title "Unavailable Items by Reason"
               :material-icon-type :warning}
     (when (and data? (>= (count top-20-keys) 20))
       [alc/pill-button-group {:selected-value selected-grouping
                               :form-path grouping-form-path
                               :form-name grouping-form-name
                               :options [{:label "Top 20" :value "top-20"}
                                         {:label "All Items" :value "all"}]}])
     (if data?
       [recharts.c/sankey-chart
        {:nodes (:nodes chart-data)
         :links (:links chart-data)
         :link-config {:on-double-click (fn [e {:keys [payload]}]
                                          (let [menu-item (-> payload :source :name)
                                                tag-value (get reason->reason-raw (-> payload :target :name))
                                                fd (sessions.d/filters->query-param
                                                     [{:by "tags"
                                                       :condition "include"
                                                       :join "or"
                                                       :value [{:name "unavailable"
                                                                :value tag-value}]
                                                       :children [{:by "menu-item"
                                                                   :condition "include"
                                                                   :join "or"
                                                                   :value [menu-item]}]}])]
                                            (router/open-route-based-on-event
                                              e
                                              [:vi/sessions nil (assoc sessions-query-params
                                                                  :svm "utterances"
                                                                  :fd fd)])))}
         :tooltip-config {:sort-by-value? true
                          :limit 20
                          :show-double-click-message? true}
         :height (recharts.util/sankey-chart-height chart-data)
         :node-padding 20
         :margin {:left 240 :right 240 :top 20 :bottom 20}}]
       [empty-state/no-chart-data {}])]))

(defn unavailable-items-by-time-card []
  (let [tags-list @(re/subscribe [:vi-tags/list-by-current-concept-id-])
        grouping-form-path items.charts.d/charts-settings-path
        item-count-form-name :unavailable-items-by-time-item-count-value
        time-period-form-name :unavailable-items-by-time-period-value
        selected-item-count @(re/subscribe [:form/val- grouping-form-path item-count-form-name])
        selected-time-period @(re/subscribe [:form/val- grouping-form-path time-period-form-name])
        selected-time-period (or selected-time-period "hourly")
        all-charts-data @(re/subscribe [:vi-items/charts-data-])
        sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        unavailable-items-by-time (some-> (util/when-not-loading all-charts-data)
                                          :unavailable-items-by-time
                                          (util/when-not-empty))
        daily-day->time-value (build-daily-day->time-value unavailable-items-by-time)
        data? (or (util/loading? all-charts-data) unavailable-items-by-time)
        grouping-config (case selected-time-period
                          "hourly" {:key :hour :label "Hour"}
                          "daily" {:key :day :label "Day"}
                          "day-of-week" {:key :day-of-week :label "Day of Week"}
                          {:key :hour :label "Hour"})
        source-key (:key grouping-config)
        grouping-keyword (keyword selected-time-period)
        {:keys [data top-20-keys]} (get unavailable-items-by-time grouping-keyword)
        chart-data (some->> data
                            (#(if (= selected-item-count "all")
                                %
                                (filterv (fn [{:keys [item]}] (contains? top-20-keys item)) %)))
                            (hash-map :source-key source-key
                                      :source-colors items.d/item-color
                                      :target-key :item
                                      :target-config {}
                                      :target-colors items.d/item-color
                                      :sort-targets-by-key? true
                                      :value-key :count
                                      :data)
                            (recharts.util/build-sankey-data))
        has-20-keys? (>= (count top-20-keys) 20)]
    [alc/card {:title "Unavailable Items by Time"
               :material-icon-type :warning}
     [:div {:style {:display :flex
                    :flex-direction :column
                    :gap 12}}
      (when data?
        [:div {:style {:display :flex
                       :align-items :center
                       :gap 12}}
         (when has-20-keys?
           [alc/pill-button-group {:selected-value selected-item-count
                                   :form-path grouping-form-path
                                   :form-name item-count-form-name
                                   :options [{:label "Top 20" :value "top-20"}
                                             {:label "All Items" :value "all"}]}])
         (when has-20-keys?
           [l/header-divider])
         [alc/pill-button-group {:selected-value selected-time-period
                                 :form-path grouping-form-path
                                 :form-name time-period-form-name
                                 :options [{:label "Hourly" :value "hourly"}
                                           {:label "Daily" :value "daily"}
                                           {:label "Day of Week" :value "day-of-week"}]}]])]
     (if data?
       [recharts.c/sankey-chart
        {:nodes (:nodes chart-data)
         :links (:links chart-data)
         :link-config {:on-double-click (fn [e {:keys [payload]}]
                                          (when (util/not-loading? tags-list)
                                            (let [time-period-value (-> payload :source :name)
                                                  menu-item (-> payload :target :name)
                                                  convert-daily (fn [day]
                                                                  (get daily-day->time-value day))
                                                  fd (->> [(condp = selected-time-period
                                                             "hourly"
                                                             (let [hour (items.charts.d/time-of-day->filter-val
                                                                          time-period-value)]
                                                               {:by "time-of-day"
                                                                :condition "include"
                                                                :join "or"
                                                                :value [{:name hour
                                                                         :value (util/time-of-day-with-leading-zero
                                                                                  hour)}]})

                                                             "day-of-week"
                                                             {:by "day-of-week"
                                                              :condition "include"
                                                              :join "or"
                                                              :value [{:name time-period-value
                                                                       :value time-period-value}]}

                                                             nil)
                                                           {:by "tags"
                                                            :condition "include"
                                                            :join "or"
                                                            :value (->> (tags.d/all-tags tags-list)
                                                                        (filterv #(= (some-> (:name %) (s/lower-case))
                                                                                     "unavailable"))
                                                                        (tags.d/tags->name-value-pairs)
                                                                        (vec))
                                                            :children [{:by "menu-item"
                                                                        :condition "include"
                                                                        :join "or"
                                                                        :value [menu-item]}]}]
                                                          (filterv identity)
                                                          (sessions.d/filters->query-param))]
                                              (router/open-route-based-on-event
                                                e
                                                [:vi/sessions nil (cond-> (assoc sessions-query-params
                                                                            :svm "utterances"
                                                                            :fd fd)
                                                                          (= selected-time-period "daily")
                                                                          (assoc :tf -1
                                                                                 :start (convert-daily time-period-value)
                                                                                 :end (convert-daily time-period-value)))]))))}
         :tooltip-config {:sort-by-value? true
                          :limit 20
                          :show-double-click-message? true}
         :height (recharts.util/sankey-chart-height chart-data)
         :node-padding 20
         :margin {:left 140 :right 240 :top 20 :bottom 20}}]
       [empty-state/no-chart-data {}])]))

(defn unavailable-reasons-by-time-card []
  (let [grouping-form-path items.charts.d/charts-settings-path
        grouping-form-name :unavailable-reasons-by-time-grouping-value
        selected-grouping @(re/subscribe [:form/val- grouping-form-path grouping-form-name])
        selected-grouping (or selected-grouping "hourly")
        all-charts-data @(re/subscribe [:vi-items/charts-data-])
        sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        unavailable-reasons-by-time (some-> (util/when-not-loading all-charts-data)
                                            :unavailable-reasons-by-time
                                            (util/when-not-empty))
        daily-day->time-value (build-daily-day->time-value unavailable-reasons-by-time)
        data? (or (util/loading? all-charts-data) unavailable-reasons-by-time)
        grouping-config (case selected-grouping
                          "hourly" {:key :hour :label "Hour"}
                          "daily" {:key :day :label "Day"}
                          "day-of-week" {:key :day-of-week :label "Day of Week"}
                          {:key :hour :label "Hour"})
        source-key (:key grouping-config)
        grouping-keyword (keyword selected-grouping)
        {:keys [data]} (get unavailable-reasons-by-time grouping-keyword)
        reason->reason-raw (build-reason->reason-raw data)
        chart-data (some->> data
                            (hash-map :source-key source-key
                                      :source-colors items.d/item-color
                                      :target-key :reason
                                      :target-config {:color (tag.d/utterance-tag-name->color "unavailable")
                                                      :header-description-fn #(tag.d/tag->description
                                                                                {:name "unavailable"
                                                                                 :value (reason->reason-raw (:name %))})}
                                      :value-key :count
                                      :data)
                            (recharts.util/build-sankey-data))]
    [alc/card {:title "Unavailable Reasons by Time"
               :material-icon-type :warning}
     (when data?
       [alc/pill-button-group {:selected-value selected-grouping
                               :form-path grouping-form-path
                               :form-name grouping-form-name
                               :options [{:label "Hourly" :value "hourly"}
                                         {:label "Daily" :value "daily"}
                                         {:label "Day of Week" :value "day-of-week"}]}])
     (if data?
       [recharts.c/sankey-chart
        {:nodes (:nodes chart-data)
         :links (:links chart-data)
         :link-config {:on-double-click (fn [e {:keys [payload]}]
                                          (let [time-period-value (-> payload :source :name)
                                                display-tag-value (-> payload :target :name)
                                                convert-daily (fn [day]
                                                                (get daily-day->time-value day))
                                                fd (->> [(condp = selected-grouping
                                                           "hourly"
                                                           (let [hour (items.charts.d/time-of-day->filter-val
                                                                        time-period-value)]
                                                             {:by "time-of-day"
                                                              :condition "include"
                                                              :join "or"
                                                              :value [{:name hour
                                                                       :value (util/time-of-day-with-leading-zero
                                                                                hour)}]})

                                                           "day-of-week"
                                                           {:by "day-of-week"
                                                            :condition "include"
                                                            :join "or"
                                                            :value [{:name time-period-value
                                                                     :value time-period-value}]}

                                                           nil)
                                                         {:by "tags"
                                                          :condition "include"
                                                          :join "or"
                                                          :value [{:name "unavailable"
                                                                   :value (get reason->reason-raw display-tag-value)}]}]
                                                        (filterv identity)
                                                        (sessions.d/filters->query-param))]
                                            (router/open-route-based-on-event
                                              e
                                              [:vi/sessions nil (cond-> (assoc sessions-query-params
                                                                          :svm "utterances"
                                                                          :fd fd)
                                                                        (= selected-grouping "daily")
                                                                        (assoc :tf -1
                                                                               :start (convert-daily time-period-value)
                                                                               :end (convert-daily time-period-value)))])))}
         :tooltip-config {:sort-by-value? true
                          :limit 20
                          :show-double-click-message? true}
         :height (recharts.util/sankey-chart-height chart-data)
         :node-padding 20
         :margin {:left 140 :right 240 :top 20 :bottom 20}}]
       [empty-state/no-chart-data {}])]))

(defn customer-upsell-acceptance-and-rejection-by-time-card []
  (let [grouping-form-path items.charts.d/charts-settings-path
        grouping-form-name :customer-upsell-results-by-time-grouping-value
        selected-grouping @(re/subscribe [:form/val- grouping-form-path grouping-form-name])
        selected-grouping (or selected-grouping "hourly")
        all-charts-data @(re/subscribe [:vi-items/charts-data-])
        sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        upsell-results-by-time (some-> (util/when-not-loading all-charts-data)
                                       :customer-upsell-results-by-time
                                       (util/when-not-empty))
        daily-day->time-value (build-daily-day->time-value upsell-results-by-time)
        data? (or (util/loading? all-charts-data) upsell-results-by-time)
        grouping-config (case selected-grouping
                          "hourly" {:key :hour :label "Hour"}
                          "daily" {:key :day :label "Day"}
                          "day-of-week" {:key :day-of-week :label "Day of Week"}
                          {:key :hour :label "Hour"})
        source-key (:key grouping-config)
        grouping-keyword (keyword selected-grouping)
        {:keys [data]} (get upsell-results-by-time grouping-keyword)
        result->result-raw (build-result->result-raw data)
        chart-data (some->> data
                            (hash-map :source-key source-key
                                      :source-colors items.d/item-color
                                      :target-key :result
                                      :target-config {:color (tag.d/utterance-tag-name->color "customer-upsell")
                                                      :header-description-fn #(tag.d/tag->description
                                                                                {:name "customer-upsell"
                                                                                 :value (result->result-raw (:name %))})}
                                      :sort-targets-by-key? true
                                      :value-key :count
                                      :data)
                            (recharts.util/build-sankey-data))]
    [alc/card {:title "Customer Upsell Acceptance and Rejection by Time"
               :material-icon-type :request-quote}
     (when data?
       [alc/pill-button-group {:selected-value selected-grouping
                               :form-path grouping-form-path
                               :form-name grouping-form-name
                               :options [{:label "Hourly" :value "hourly"}
                                         {:label "Daily" :value "daily"}
                                         {:label "Day of Week" :value "day-of-week"}]}])
     (if data?
       [recharts.c/sankey-chart
        {:nodes (:nodes chart-data)
         :links (:links chart-data)
         :link-config {:on-double-click (fn [e {:keys [payload]}]
                                          (let [time-period-value (-> payload :source :name)
                                                display-tag-value (-> payload :target :name)
                                                convert-daily (fn [day]
                                                                (get daily-day->time-value day))
                                                {:keys [upsell-value outcome-value]} (get result->result-raw
                                                                                          display-tag-value)
                                                fd (->> [(condp = selected-grouping
                                                           "hourly"
                                                           (let [hour (items.charts.d/time-of-day->filter-val
                                                                        time-period-value)]
                                                             {:by "time-of-day"
                                                              :condition "include"
                                                              :join "or"
                                                              :value [{:name hour
                                                                       :value (util/time-of-day-with-leading-zero
                                                                                hour)}]})

                                                           "day-of-week"
                                                           {:by "day-of-week"
                                                            :condition "include"
                                                            :join "or"
                                                            :value [{:name time-period-value
                                                                     :value time-period-value}]}

                                                           nil)
                                                         {:by "tags"
                                                          :condition "include"
                                                          :join "or"
                                                          :value [{:name "crew-upsell"
                                                                   :value upsell-value}]
                                                          :children [{:by "outcome"
                                                                      :condition "include"
                                                                      :join "or"
                                                                      :value [outcome-value]}]}]
                                                        (filterv identity)
                                                        (sessions.d/filters->query-param))]
                                            (when (and upsell-value outcome-value)
                                              (router/open-route-based-on-event
                                                e
                                                [:vi/sessions nil (cond-> (assoc sessions-query-params
                                                                            :svm "utterances"
                                                                            :fd fd)
                                                                          (= selected-grouping "daily")
                                                                          (assoc :tf -1
                                                                                 :start (convert-daily time-period-value)
                                                                                 :end (convert-daily time-period-value)))]))))}
         :tooltip-config {:sort-by-value? true
                          :limit 20
                          :show-double-click-message? true}
         :height (recharts.util/sankey-chart-height chart-data)
         :node-padding 20
         :margin {:left 140 :right 240 :top 20 :bottom 20}}]
       [empty-state/no-chart-data {}])]))

(defn crew-upsell-card [_]
  (let [set-initial-limit?* (re/ratom false)]
    (fn [{:keys [upsell-type]}]
      (let [sort-form-name (keyword (str "crew-upsell-" upsell-type "-items-sort-value"))
            selected-sort (or @(re/subscribe [:form/val- items.charts.d/charts-settings-path sort-form-name]) "count")
            limit-count-form-name (keyword (str "crew-upsell-" upsell-type "-items-limit-count-value"))
            limit-count (some-> @(re/subscribe [:form/val- items.charts.d/charts-settings-path limit-count-form-name])
                                (util/parse-int))
            add-limit-form-name (keyword (str "crew-upsell-" upsell-type "-items-add-limit-value"))
            add-limit-value @(re/subscribe [:form/val- items.charts.d/charts-settings-path add-limit-form-name])
            add-limit? (if (nil? add-limit-value) true add-limit-value)
            limit-operator-form-name (keyword (str "crew-upsell-" upsell-type "-items-limit-operator-value"))
            selected-limit-operator (or @(re/subscribe [:form/val- items.charts.d/charts-settings-path limit-operator-form-name]) "more-than")
            limit-operator (if (= selected-limit-operator "less-than") < >)
            all-charts-data @(re/subscribe [:vi-items/charts-data-])
            sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
            customer-upsell-data (some-> (util/when-not-loading all-charts-data)
                                         (get (keyword (str "customer-upsell-" upsell-type)))
                                         (util/when-not-empty))
            data? (or (util/loading? all-charts-data) customer-upsell-data)
            upsell-label (tag/tag->display-name {:value upsell-type})
            upsell-full-accept-key (str upsell-type ".accept")
            upsell-full-decline-key (str upsell-type ".decline")
            {:keys [data]} customer-upsell-data
            filtered-data (->> (if (and add-limit? (pos? limit-count))
                                 (filterv (fn [item]
                                            (limit-operator (:total item) limit-count))
                                          data)
                                 data)
                               (sort-by #(condp = selected-sort
                                           "count" (:total %)
                                           "accept" (/ (get % upsell-full-accept-key) (:total %))
                                           "decline" (/ (get % upsell-full-decline-key) (:total %))))
                               (reverse))
            filtered-data? (not-empty filtered-data)
            data-keys (->> filtered-data
                           (map keys)
                           (flatten)
                           (remove #(contains? #{:name :total :percent-val :tooltip-value} %))
                           (distinct)
                           (vec))
            chart-height 620]
        (when (and (not @set-initial-limit?*) data?)
          (let [init-limit (when (> (count data) 20)
                             (->> data
                                  (sort-by :total)
                                  (reverse)
                                  (take 20)
                                  (last)
                                  :total
                                  (dec)))]
            (when (pos? init-limit)
              (re/dispatch [:form/change items.charts.d/charts-settings-path limit-count-form-name init-limit]))
            (reset! set-initial-limit?* true)))
        [alc/card {:title (str "Upsell: " upsell-label)
                   :material-icon-type :request-quote}
         (when data?
           [:div {:style {:display :flex
                          :align-items :center
                          :gap 8}}
            [:span {:style {:color (style/alc-color "Text/primary")
                            :font-size 13
                            :font-weight 500
                            :line-height 1.2}}
             "Sort By"]
            [alc/pill-button-group {:selected-value selected-sort
                                    :form-path items.charts.d/charts-settings-path
                                    :form-name sort-form-name
                                    :options [{:label "Count" :value "count"}
                                              {:label "Accept %" :value "accept"}
                                              {:label "Decline %" :value "decline"}]}]])
         (if (or filtered-data? data?)
           [:div {:style {:display :flex
                          :flex-direction :column
                          :gap 16}}
            (if filtered-data?
              (let [filtered-data-count (count filtered-data)]
                [recharts.c/stacked-bar-chart
                 {:chart-data filtered-data
                  :data-keys data-keys
                  :colors {upsell-full-accept-key (style/alc-color "chart/green")
                           upsell-full-decline-key (style/alc-color "chart/red")}
                  :x-axis-config {:angle -45
                                  :height 140}
                  :use-gradients false
                  :stack-separator "."
                  :show-legend false
                  :chart-height chart-height
                  :chart-width (max (* filtered-data-count 70) 250)
                  :chart-container-style {:align-items :center}
                  :chart-style {:padding "0 10px"
                                :width :auto
                                :max-width "100%"}
                  :tooltip-label-transf-fn #(tag/tag->display-name {:value %})
                  :tooltip-header-transf-fn #(-> @(:tooltip-state* %) :data :name)
                  :tooltip-config {:show-double-click-message? true}
                  :bar-config {:on-double-click (fn [click-data _ e]
                                                  (let [menu-item (-> click-data :payload :name)
                                                        tag-parts (some-> click-data
                                                                          :tooltipPayload
                                                                          (first)
                                                                          :name
                                                                          (name)
                                                                          (s/split "."))]
                                                    (when (some-> tag-parts (count) (= 2))
                                                      (router/open-route-based-on-event
                                                        e
                                                        [:vi/sessions nil (assoc sessions-query-params
                                                                            :svm "utterances"
                                                                            :fd (sessions.d/filters->query-param
                                                                                  [{:by "tags"
                                                                                    :condition "include"
                                                                                    :join "or"
                                                                                    :value [{:name "crew-upsell"
                                                                                             :value upsell-type}]
                                                                                    :children [{:by "menu-item"
                                                                                                :condition "include"
                                                                                                :join "or"
                                                                                                :value [menu-item]}
                                                                                               {:by "outcome"
                                                                                                :condition "include"
                                                                                                :join "or"
                                                                                                :value [(last tag-parts)]}]}]))]))))}}])
              [empty-state/no-data-card {:material-icon-type :insert-chart
                                         :text "No data for specified offered upsell limit"
                                         :style {:background-color :none
                                                 :display :flex
                                                 :align-items :center
                                                 :justify-content :center
                                                 :flex (str "0 0 " chart-height "px")
                                                 :padding 0}}])
            (let [text-style (cond-> {:color (style/alc-color "Text/primary")
                                      :font-size 16
                                      :font-weight 400
                                      :line-height 1.43
                                      :flex "0 0 auto"
                                      :user-select :none}
                                     (not add-limit?)
                                     (assoc :opacity 0.5))]
              [:div {:style {:display :flex
                             :align-items :center
                             :gap 8}}
               [alc/up-checkbox {:form-path items.charts.d/charts-settings-path
                                 :form-name add-limit-form-name
                                 :checked add-limit?}]
               [:span {:style text-style}
                "Only show upsells offered"]
               [alc/up-dropdown {:form-path items.charts.d/charts-settings-path
                                 :form-name limit-operator-form-name
                                 :value selected-limit-operator
                                 :disabled (not add-limit?)
                                 :placeholder "More Than"
                                 :options [{:text "More Than"
                                            :value "more-than"}
                                           {:text "Less Than"
                                            :value "less-than"}]
                                 :style {:max-width 160}}]
               [alc/up-input {:form-path items.charts.d/charts-settings-path
                              :form-name limit-count-form-name
                              :regex regexes/number??
                              :placeholder "Count"
                              :disabled (not add-limit?)
                              :style {:max-width 65}}]
               [:span {:style text-style}
                (util/pluralize "time" (or limit-count 0))]])]
           [empty-state/no-chart-data {}])]))))

(defn customer-questions-card []
  (let [grouping-form-path items.charts.d/charts-settings-path
        grouping-form-name :customer-questions-grouping-value
        selected-grouping @(re/subscribe [:form/val- grouping-form-path grouping-form-name])
        all-charts-data @(re/subscribe [:vi-items/charts-data-])
        sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        question-items-data (some-> (util/when-not-loading all-charts-data)
                                    :question-items
                                    (util/when-not-empty))
        question-value->question-value-raw (build-question-value->question-value-raw (:data question-items-data))
        data? (or (util/loading? all-charts-data) question-items-data)
        {:keys [data top-20-keys]} question-items-data
        chart-data (some->> data
                            (#(if (= selected-grouping "all")
                                %
                                (filterv (fn [{:keys [item]}] (contains? top-20-keys item)) %)))
                            (hash-map :source-key :question-value
                                      :sort-sources-by-key? true
                                      :source-colors items.d/item-color
                                      :target-key :item
                                      :sort-targets-by-key? true
                                      :target-colors items.d/item-color
                                      :value-key :count
                                      :data)
                            (recharts.util/build-sankey-data))]
    [alc/card {:title "Customer Questions by Menu Item"
               :icon-type :QuestionmarkCircleIcon}
     (when (and data? (>= (count top-20-keys) 20))
       [alc/pill-button-group {:selected-value selected-grouping
                               :form-path grouping-form-path
                               :form-name grouping-form-name
                               :options [{:label "Top 20" :value "top-20"}
                                         {:label "All Items" :value "all"}]}])
     (if data?
       [recharts.c/sankey-chart
        {:nodes (:nodes chart-data)
         :links (:links chart-data)
         :link-config {:on-double-click (fn [e {:keys [payload]}]
                                          (let [question-value (-> payload :source :name)
                                                menu-item (-> payload :target :name)
                                                fd (sessions.d/filters->query-param
                                                     [{:by "tags"
                                                       :condition "include"
                                                       :join "or"
                                                       :value [{:name "question"
                                                                :value (get question-value->question-value-raw
                                                                            question-value)}]
                                                       :children [{:by "menu-item"
                                                                   :condition "include"
                                                                   :join "or"
                                                                   :value [menu-item]}]}])]
                                            (router/open-route-based-on-event
                                              e
                                              [:vi/sessions nil (assoc sessions-query-params
                                                                  :svm "utterances"
                                                                  :fd fd)])))}
         :tooltip-config {:sort-by-value? true
                          :limit 20
                          :show-double-click-message? true}
         :height (recharts.util/sankey-chart-height chart-data)
         :node-padding 20
         :margin {:left 240 :right 240 :top 20 :bottom 20}}]
       [empty-state/no-chart-data {}])]))

(defn charts-view []
  (let [charts-data (util/when-not-loading @(re/subscribe [:vi-items/charts-data-]))
        unavailable-items? (or (not-empty (:unavailable-items-by-reason charts-data))
                               (not-empty (:unavailable-items-by-time charts-data))
                               (not-empty (:unavailable-reasons-by-time charts-data)))
        upsell-performance? (or (not-empty (:customer-upsell-results-by-time charts-data))
                                (not-empty (:customer-upsell-add-on charts-data))
                                (not-empty (:customer-upsell-size charts-data))
                                (not-empty (:customer-upsell-combo charts-data)))
        customer-questions? (not-empty (:question-items charts-data))]
    (if (or unavailable-items? upsell-performance? customer-questions?)
      [:div {:style {:display :flex
                     :flex-direction :column
                     :gap 12}}
       [l/section-header {}
        "Unavailable Items"]
       [unavailable-items-by-reason-card]
       [unavailable-items-by-time-card]
       [unavailable-reasons-by-time-card]
       [l/section-header {}
        "Upsell Performance"]
       [customer-upsell-acceptance-and-rejection-by-time-card]
       [crew-upsell-card {:upsell-type "add-on"}]
       [crew-upsell-card {:upsell-type "size"}]
       [crew-upsell-card {:upsell-type "combo"}]
       [l/section-header {}
        "Customer Questions"]
       [customer-questions-card]]
      [empty-state/no-data-card {:text "No items data available"}])))
